import type { PedigreeType } from '@application/types';
import type { CountryCode } from '@gql/graphql';
import type {
  CardItemStudData,
  FiltersWithModalData,
  SelectOption,
} from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface StudListPageFormOptions {
  breeds: SelectOption<string>[];
  regions: SelectOption<string>[];
}

export interface StudListPageFormValues {
  countries?: CountryCode[];
  breedNames?: string[];
  pedigree?: PedigreeType[];
  champion?: boolean;
  regions?: string[];
}

export interface StudListPageProps {
  items?: CardItemStudData[];
  loading?: boolean;

  loadMoreLoading?: boolean;
  onLoadMoreClick?: MouseEventHandler;
  loadMoreText?: string;
  canLoadMore?: boolean;

  formOptions: StudListPageFormOptions;
  filtersModal: FiltersWithModalData;
}
